const listDefaultPageActions = [
    {
        title: 'Add New',
        to: '/special',
    },
];

export const listPageActions = (displayType, anyDisabled) => {
    switch (displayType) {
        case 'disabled':
            return [
                {
                    title: 'Show Active',
                    to: '/specials',
                },
                ...listDefaultPageActions,
            ];
        case 'active':
        default:
            if (anyDisabled) {
                return [
                    {
                        title: 'Show Disabled',
                        to: '/specials/disabled',
                    },
                    ...listDefaultPageActions,
                ];
            } else {
                return listDefaultPageActions;
            }
    }
};

export const editPageActions = [
    {
        title: 'Back',
        to: '/specials',
    },
];
